export default {
  /**
   * @description api请求基础路径
   */
  development : {
    passportUrl: 'https://passport-daily.shui12366.com/',
    mallUrl: 'http://zsdy-mall-pc-daily.shui12366.com/goodsType?appCode=sbw',
    mallOrderUrl: 'http://zsdy-mall-pc-daily.shui12366.com/order?appCode=sbw',
    appUrl:'https://zsdy-mall-frontend-daily.shui12366.com/sbwApi/watch/live/',
    cjtUrl:'https://inte-www.chanjet.com/news/f/101593.html?a=&c=',
  },
  production : {
    passportUrl: 'https://passport.shui12366.com/',
    mallUrl: 'http://zsdy-mall-pc.shui12366.com/goodsType?appCode=sbw',
    mallOrderUrl: 'http://zsdy-mall-pc.shui12366.com/order?appCode=sbw',
    appUrl:'https://zsdy-mall-frontend.shui12366.com/sbwApi/watch/live/',
    cjtUrl:'https://www.chanjet.com/news/f/102658.html?a=bjzsdy&c=asktax',
  }

}
